import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Divider,
  List,
  ListItem,
  ListIcon,
} from "@chakra-ui/react";
import { MdWarning } from "react-icons/md";

const DisclaimerPage = () => {
  return (
    <Box bg="gray.50" minH="100vh" py={10}>
      <Container maxW="container.lg">
        <VStack spacing={8} align="stretch">
          {/* Header */}
          <Box textAlign="center" mb={4}>
            <Heading size="2xl" color="gray.800" mb={4}>
              Disclaimer & Liability Notice
            </Heading>
            <Text fontSize="lg" color="gray.600">
              Important Information - Please Read Carefully
            </Text>
          </Box>

          {/* Main Disclaimer */}
          <Box
            bg="white"
            p={8}
            borderRadius="lg"
            shadow="md"
            borderWidth="2px"
            borderColor="orange.200"
          >
            <VStack spacing={6} align="stretch">
              <Heading size="lg" color="orange.600">
                Limitation of Liability
              </Heading>

              <Text fontSize="md" color="gray.700" lineHeight="tall">
                By using our platform and services, you acknowledge and agree
                that our company, its owners, employees, and affiliates shall
                not be held liable for any damages, injuries, losses, or other
                negative consequences that may arise from the use of our
                services or interactions with service providers listed on our
                platform.
              </Text>

              <Divider />

              <Heading size="md" color="gray.700">
                No Liability for:
              </Heading>

              <List spacing={3}>
                <ListItem display="flex" alignItems="start">
                  <ListIcon as={MdWarning} color="orange.500" mt={1} />
                  <Text>
                    <strong>Personal Injury or Property Damage:</strong> We are
                    not responsible for any personal injuries, accidents, or
                    property damage that may occur during or as a result of
                    services provided by vendors on our platform.
                  </Text>
                </ListItem>

                <ListItem display="flex" alignItems="start">
                  <ListIcon as={MdWarning} color="orange.500" mt={1} />
                  <Text>
                    <strong>Quality of Work:</strong> We do not guarantee the
                    quality, completeness, accuracy, or timeliness of work
                    performed by service providers. All work arrangements are
                    between you and the vendor directly.
                  </Text>
                </ListItem>

                <ListItem display="flex" alignItems="start">
                  <ListIcon as={MdWarning} color="orange.500" mt={1} />
                  <Text>
                    <strong>Financial Losses:</strong> We are not liable for any
                    financial losses, including but not limited to costs of
                    repairs, replacement expenses, or lost income resulting from
                    services obtained through our platform.
                  </Text>
                </ListItem>

                <ListItem display="flex" alignItems="start">
                  <ListIcon as={MdWarning} color="orange.500" mt={1} />
                  <Text>
                    <strong>Vendor Actions:</strong> We are not responsible for
                    the actions, conduct, negligence, or professional competence
                    of any vendors listed on our platform. Vendors are
                    independent contractors.
                  </Text>
                </ListItem>

                <ListItem display="flex" alignItems="start">
                  <ListIcon as={MdWarning} color="orange.500" mt={1} />
                  <Text>
                    <strong>Health and Safety Issues:</strong> We are not liable
                    for any health or safety issues, hazardous conditions, or
                    code violations that may arise from work performed by
                    vendors.
                  </Text>
                </ListItem>

                <ListItem display="flex" alignItems="start">
                  <ListIcon as={MdWarning} color="orange.500" mt={1} />
                  <Text>
                    <strong>Disputes:</strong> Any disputes, disagreements, or
                    legal matters arising between customers and vendors are
                    solely the responsibility of the involved parties. We are
                    not a party to such disputes.
                  </Text>
                </ListItem>

                <ListItem display="flex" alignItems="start">
                  <ListIcon as={MdWarning} color="orange.500" mt={1} />
                  <Text>
                    <strong>Technical Issues:</strong> We are not responsible
                    for any damages or losses resulting from platform technical
                    issues, service interruptions, or data loss.
                  </Text>
                </ListItem>
              </List>

              <Divider />

              <Box bg="orange.50" p={4} borderRadius="md">
                <Heading size="sm" color="orange.700" mb={2}>
                  User Responsibility
                </Heading>
                <Text fontSize="sm" color="gray.700">
                  Users are solely responsible for:
                </Text>
                <List spacing={2} mt={2} ml={4}>
                  <ListItem fontSize="sm">
                    • Verifying vendor credentials, licenses, and insurance
                  </ListItem>
                  <ListItem fontSize="sm">
                    • Obtaining necessary permits and approvals for work
                  </ListItem>
                  <ListItem fontSize="sm">
                    • Ensuring proper contracts and agreements with vendors
                  </ListItem>
                  <ListItem fontSize="sm">
                    • Conducting due diligence before hiring any service
                    provider
                  </ListItem>
                  <ListItem fontSize="sm">
                    • Maintaining adequate insurance coverage
                  </ListItem>
                </List>
              </Box>

              <Divider />

              <Heading size="md" color="gray.700">
                Platform Role
              </Heading>

              <Text fontSize="md" color="gray.700" lineHeight="tall">
                Our platform serves solely as a connection service between
                customers and service providers. We do not employ, endorse,
                recommend, or guarantee any vendors listed on our platform. We
                are not involved in the actual provision of services and do not
                supervise, direct, or control the services provided.
              </Text>

              <Divider />

              <Heading size="md" color="gray.700">
                Use at Your Own Risk
              </Heading>

              <Text fontSize="md" color="gray.700" lineHeight="tall">
                By using our platform, you explicitly acknowledge that you use
                the service at your own risk. You agree to indemnify and hold
                harmless our company, its officers, directors, employees, and
                agents from any claims, damages, losses, liabilities, and
                expenses (including legal fees) arising from your use of the
                platform or services obtained through it.
              </Text>

              <Box
                bg="red.50"
                p={4}
                borderRadius="md"
                borderWidth="1px"
                borderColor="red.200"
              >
                <Text fontSize="sm" color="red.700" fontWeight="bold">
                  IMPORTANT: By continuing to use this platform, you acknowledge
                  that you have read, understood, and agree to this disclaimer.
                  If you do not agree with these terms, please discontinue use
                  of our services immediately.
                </Text>
              </Box>

              <Divider />

              <Text fontSize="xs" color="gray.500" textAlign="center">
                Last Updated: January 7, 2026
              </Text>
            </VStack>
          </Box>
        </VStack>
      </Container>
    </Box>
  );
};

export default DisclaimerPage;
